import React, {Component} from "react";
import "../../VisitHistory.css";

export default class ComplaintViewHistory extends Component {
    render() {
        if (this.props.complaint == null
            ||
            ((this.props.complaint.complaint == null || this.props.complaint.complaint === " ")
                && !this.props.complaint.secondaryClinicalFindings?.length)) {
            return <div className="pl-3">No information available</div>;
        }
        const snomedCodes = (this.props.complaint.secondaryClinicalFindings || [])
            .map(finding => finding.name).filter(Boolean).join(", ");
        return (
            <div className="pl-3">
                <div className={"visit-history-content"}>
                    <span className="d-block mb-3">
                        {this.props.complaint.complaint == null || this.props.complaint.complaint === " " ? "NA"
                            : this.props.complaint.complaint}
                    </span>

                    <span className="d-block mb-1 font-weight-bold">
                            SNOMED code:
                    </span>

                    <span className="d-block">
                        {snomedCodes === "" ? "NA" : snomedCodes}
                    </span>
                </div>
            </div>
        );
    }
}
